function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u90AE\u4EF6");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-1126.000000, -352.000000)",
  fill: "#1B1464",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u65B9\\u5F0F",
  transform: "translate(1126.000000, 229.000000)"
}, React.createElement("path", {
  d: "M2.94525303,128.09467 C3.10216794,128.036478 3.27008425,128 3.4475544,128 L20.5286966,128 C20.7061668,128 20.8740831,128.036478 21.030998,128.09467 L13.3777778,135.30436 C12.598704,136.038849 11.3778366,136.038849 10.5984733,135.30436 L2.94525303,128.09467 Z M21.7628815,140.906395 C21.8954775,140.687815 21.976251,140.433913 21.976251,140.159457 L21.976251,129.447554 C21.976251,129.253003 21.936588,129.068006 21.8668159,128.898352 L14.7048957,135.645114 L21.7628815,140.906395 Z M14.0572598,136.24527 C13.462894,136.75452 12.7266678,137.012763 11.9881255,137.012763 C11.2495833,137.012763 10.5133571,136.754809 9.91899122,136.24527 L2.8809816,141.491497 C3.05526718,141.565612 3.24634435,141.607012 3.4475544,141.607012 L20.5286966,141.607012 C20.7299067,141.607012 20.9209839,141.565612 21.0952694,141.491497 L14.0572598,136.24527 Z M2.10943511,128.898352 C2.03966298,129.068006 2,129.253003 2,129.447554 L2,140.159457 C2,140.433913 2.08077354,140.687815 2.21336952,140.906395 L9.27135537,135.645114 L2.10943511,128.898352 Z",
  id: "Shape"
}))));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.54c37880.svg";
export { ForwardRef as ReactComponent };